import i18next from 'i18next';
import * as yup from 'yup';

export const yupStringRequired = yup
  .string()
  .transform((value) => value.trim())
  .required(i18next.t('yup-validation-string-required'));
